import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detailledgerpage',
  templateUrl: './detailledgerpage.component.html',
  styleUrls: ['./detailledgerpage.component.sass']
})
export class DetailledgerpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
